import { render, staticRenderFns } from "./iFrameEditor.vue?vue&type=template&id=cc6f0768"
import script from "./iFrameEditor.vue?vue&type=script&lang=js"
export * from "./iFrameEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports